import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', '2020793225485829');
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-70">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=2020793225485829&ev=PageView&noscript=1" alt="" data-id="element-71" />
    </noscript>;
}